import { MOCK_PLUGIN_ID_PREFIX } from '../consts';
export function formPurchaseBackendUrl(urlPath = '/') {
    const url = new URL(urlPath, import.meta.env.PURCHASE_BACKEND_URL);
    if (process.env.NODE_ENV === 'production') {
        return url.toString();
    }
    const devGatewayUrl = new URL(urlPath, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? import.meta.env.DEV_PURCHASE_BACKEND_INSECURE_GATEWAY_PORT
        : import.meta.env.DEV_PURCHASE_BACKEND_SECURE_GATEWAY_PORT;
    devGatewayUrl.port = port;
    return devGatewayUrl.toString();
}
export function formPluginUrl(pluginId, urlPath = '/') {
    if (process.env.NODE_ENV === 'production') {
        return new URL(urlPath, `https://${pluginId}.streamrtvplugins.com`).toString();
    }
    if (pluginId.startsWith(MOCK_PLUGIN_ID_PREFIX)) {
        return formMockPluginUrl(pluginId, urlPath);
    }
    if (pluginId !== 'chat') {
        throw new Error(`Unknown plugin id: ${pluginId}`);
    }
    const devGatewayUrl = new URL(urlPath, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? import.meta.env.DEV_CHAT_INSECURE_GATEWAY_PORT
        : import.meta.env.DEV_CHAT_SECURE_GATEWAY_PORT;
    devGatewayUrl.port = port;
    return devGatewayUrl.toString();
}
function formMockPluginUrl(pluginId, urlPath = '/') {
    const devGatewayUrl = new URL(`/${pluginId}${urlPath}`, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? import.meta.env.DEV_MOCK_PLUGIN_INSECURE_GATEWAY
        : import.meta.env.DEV_MOCK_PLUGIN_SECURE_GATEWAY;
    devGatewayUrl.port = port;
    return devGatewayUrl.toString();
}
